module.exports = __webpack_public_path__ + "img/17.4682fe57.jpg";